import { render, staticRenderFns } from "./DataEvalRoles.vue?vue&type=template&id=98778a00"
import script from "./DataEvalRoles.vue?vue&type=script&lang=js"
export * from "./DataEvalRoles.vue?vue&type=script&lang=js"
import style0 from "./DataEvalRoles.vue?vue&type=style&index=0&id=98778a00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports